/**
 * Os tiles do mapa das entregas (F265): o OpenStreetMap.
 *
 * Aqui, e não em `components/map-view.tsx`, porque a CSP do desktop confere
 * esta origem (`desktop-csp.test.ts`) e um arquivo de componente que exporta
 * constante perde o recarregamento rápido do Vite.
 *
 * O volume de uma loja cabe na política de uso justo dos tiles do OSM. Se
 * crescer, trocar de servidor de tiles é trocar esta linha (e a CSP).
 */
export const MAP_TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'

export const MAP_TILE_ORIGIN = 'https://tile.openstreetmap.org'

export const MAP_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
